import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-warning-massage",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./warning-massage.component.html",
  styleUrl: "./warning-massage.component.scss",
})
export class WarningMassageComponent {
  @Input() warningMessage: string;
}
